// BarChartObj.container.jsx
import React from "react";
import { GroupedBarChart } from "@carbon/charts-react";
import PropTypes from 'prop-types';
import { toolbarOptions } from "./utils";

const BarChartObj = ({
    height = "400px",
    title = "Bar Chart Graph",
    data = [
        {
            "group": "Qty",
            "key": "qty",
            "value": 65000
        },
        {
            "key": "more",
            "group": "More",
            "value": 29123
        }
    ],
    targets = {}, 
    axesOptions = {
        "left": {
            "mapsTo": "group",
            "scaleType": "labels"
        },
        "bottom": {
            "mapsTo": "value"
        }
    }
}) => {
    const chartData = React.useMemo(() => {
        if (!Array.isArray(data) || data.length === 0) {
            return [];
        }

        const result = [];
        
        data.forEach(item => {
            if (!item || !item.key) return;
            
            result.push({
                group: "Real",
                key: item.key,
                value: Number(item.value) || 0
            });
            
            const targetValue = targets[item.key];
            if (targetValue !== undefined && Number(targetValue) > 0) {
                result.push({
                    group: "Objetivo",
                    key: item.key,
                    value: Number(targetValue)
                });
            }
        });
        
        console.log('ChartData generado:', result);
        
        return result;
    }, [data, targets]);

    if (!chartData || chartData.length === 0) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#f4f4f4' }}>
                No hay datos disponibles para mostrar
            </div>
        );
    }

    const options = {
        title: title,
        axes: {
            left: {
                mapsTo: "key",
                scaleType: "labels"
            },
            bottom: {
                mapsTo: "value",
                includeZero: true
            }
        },
        height: height,
        width: "100%",
        theme: "g100",
        toolbar: {
            enabled: false
        }
    };

    return (
        <GroupedBarChart
            data={chartData}
            options={options}
        />
    )
}

BarChartObj.propTypes = {
    height: PropTypes.string,
    title: PropTypes.string,
    data: PropTypes.array,
    targets: PropTypes.object, 
    axesOptions: PropTypes.object
}

export default BarChartObj;